import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class RepeatInterval extends Cloneable {
    static NONE = new RepeatInterval(0, "NONE");

    static _values = [
        this.NONE,
        new RepeatInterval(1, "DAILY"),
        new RepeatInterval(2, "WEEKLY"),
        new RepeatInterval(3, "WEEKLY_2X")
    ];

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, RepeatInterval.getValue(id));
        });
    }

    static is(value) {
        if (value instanceof RepeatInterval) {
            return RepeatInterval._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    static isNone(value) {
        return RepeatInterval.NONE.equal(value);
    }

    constructor(id = 0, name = "NONE") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    equal(value) {
        if (value instanceof RepeatInterval) {
            return this.id === value.id;
        } else if (Number.isInteger(value)) {
            return this.id === value;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new RepeatInterval());
        } else if (target instanceof RepeatInterval) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(RepeatInterval, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});